'use strict';

var _ = require('lodash');
var BaseStaticView = require('actions/shared/AbstractStaticView');
var tpl = require('actions/operatorPing/static.html');
var twig = require('twig').twig;

/**
 * Renders a text-only version of the "Ping Test" component.
 */
module.exports = BaseStaticView.extend({
  /**
   * @name actions/operatorPing/StaticView#model
   * @type {actions/operatorPing/OperatorPing}
   */

  template: twig({data: tpl}),

  templateContext: function() {
    var baseHelpers = BaseStaticView.prototype.templateContext.apply(this);

    return _.extend({}, baseHelpers, {
      resultText: this._resultText,
    });
  },

  /**
   * Format model's result value for display
   * Splits into array on newlines
   *
   * @returns {Array}
   * @private
   */
  _resultText: function() {
    return this.result.split('\n');
  },
});
